import CoreScroll from '@nrk/core-scroll'
import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getK5aRow, getK5aPosition } from './lib/kurator-k5a'

// INFO: Since preact isn't loaded in client,
// we have to import images here, so webpack will find them
import './app.module.css'
import './static/ol-ringer.png'
import './static/ol-ringer-small.png'
import './static/ol2024-logo.png'
import './static/OL2006-NRKno-banner_Composite.png'
import './static/flag-no.png'
import './static/gold-medal.png'

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

class AppElement extends BaseElement {
  name = 'dh-sportsbanner-v2'

  render() {
    this.initCoreScroll()
    this.showMoreHandler()
    // @ts-ignore
    if (this.preloadedState?.view === 'banner') {
      this.frontBannerClickHandler()
    }
  }

  frontBannerClickHandler() {
    const banner = this.querySelector<HTMLElement>('.dh-sportsbanner-dh-sports-banner__skivm2025')

    banner?.addEventListener('click', (e: PointerEvent & { target: HTMLElement }) => {
      if (e.target?.closest('a')) {
        return
      }
      banner.querySelector('a')?.click()
    })

    const links = this.querySelectorAll<HTMLAnchorElement>(
      '.dh-sportsbanner-dh-sports-banner__program-event-href'
    )

    if (links.length) {
      Array.from(links).forEach((item) => {
        item.addEventListener('click', (event) => {
          event.preventDefault()
          try {
            const titleElement = item.querySelector<HTMLSpanElement>(
              '.dh-sportsbanner-dh-sports-banner__program-event-title__name span'
            )
            const row = getK5aRow(this)
            const pos = getK5aPosition(this)
            window?.kilkaya?.click({
              url: location.href,
              type: 'frontpage',
              title: document?.title,
              row,
              pos,
              position: `main_row${row}_pos${pos}`,
              toUrl: item.href,
              toTitle: titleElement.innerText,
              toType: 'article',
            })
          } catch {
            // Ignore
          }
          window.location.href = item.href
        })
      })
    }
  }

  showMoreHandler() {
    const programSection = this.querySelector(
      '.dh-sportsbanner-dh-sports-program-section'
    ) as HTMLElement
    const showMoreButton = this.querySelector(
      '.dh-sportsbanner-dh-sports-porgram-expandable-button'
    ) as HTMLElement
    const section = this.querySelector(
      '.dh-sportsbanner-dh-sports-program__programsSection'
    ) as HTMLElement

    if (showMoreButton) {
      showMoreButton.addEventListener('click', () => {
        const expandedCls = 'dh-sportsbanner-program-expanded'
        const isExpanded = programSection.classList.contains(expandedCls)
        programSection.classList.toggle(expandedCls)
        programSection.setAttribute('tabindex', '-1')
        setTimeout(() => {
          programSection.focus()
        }, 500)
        showMoreButton.innerHTML = !isExpanded ? 'Skjul innhold' : 'Vis mer'
        section.setAttribute('aria-hidden', isExpanded.toString())
      })
    }
  }

  findClosestProgramEntry(container: HTMLElement): HTMLElement {
    // no scroll container
    if (container == null) {
      return
    }

    const today = container.querySelector<HTMLElement>('[data-today]')
    // events haven't started or last event was yesterday
    if (today == null) {
      return
    }

    const events = today.querySelectorAll<HTMLDivElement>('[data-timestamp]')
    if (events.length === 0) {
      return today
    }

    const now = new Date()
    const closestEvent = Array.from(events)
      .reverse()
      .find((el) => now > new Date(el.dataset.timestamp))

    return closestEvent ?? today
  }

  async initCoreScroll() {
    const scrollElement: HTMLElement = this.querySelector('.dh-sportsbanner-scroll')
    let scrollTarget: HTMLElement

    if (scrollElement) {
      const ongoingElements = scrollElement.querySelectorAll<HTMLElement>(
        '.dh-sportsbanner-dh-sports-banner__program-event-ongoing'
      )
      if (!ongoingElements.length) {
        scrollTarget = this.findClosestProgramEntry(scrollElement)
      } else {
        scrollTarget = ongoingElements[0]
      }

      if (scrollTarget) {
        if (document.fonts?.ready) {
          await document.fonts.ready
        }

        // core-scroll overrides Element.scroll(), so we bypass that
        Element.prototype.scroll.call(scrollElement, {
          left: scrollTarget.offsetLeft,
          behavior: 'auto',
        } as ScrollToOptions)
      }
    }
  }
}

safeDefine('dh-sportsbanner-core-scroll', CoreScroll)
safeDefine('dh-sportsbanner-v2', AppElement)
